import style from "../mailVerify/mailVerify.module.css";
import Lottie from "react-lottie";
import successAnim from "../../../lotties/mail_verify_sucess.json";
import bgImage from "../../../assets/img/Email_campaign_pana.png";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../../../adapters/xhr/api";
import { useState } from "react";
import { forgotPassowrd } from "../../../adapters/apis/auth/auth";

function CheckResetPassValidty() {
  const navigate = useNavigate();
  const url = "api/validateEmail";
  const [errMessage, setErrMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const email = query.get("email");

  const defaultOptions = {
    loop: true,
    autoplay: true,
    speed: 1,
    animationData: successAnim,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // const handleResend = async (e) => {
  function handleResend() {
    // e.preventDefault();
    setLoading(true);
    setErrMessage("");

    try {
      forgotPassowrd({ email: email })
        .then((res) => {
          // console.log("====================================");
          // console.log(res.data.code);
          // console.log("====================================");
          if (res.data.code == 422) {
            setErrMessage(res.data.status);
            setLoading(false)
          } else {
            setErrMessage(res.data.status);
            navigate(`/mail-verified?email=${email}`);
            setLoading(false)
          }
        })
        .catch((error) => {
          setErrMessage(error.response.data.message);
        })
        .finally();
    } catch (error) {
      console.error("Resend failed:", error);
      setLoading(false)
    }
    // try {
    //   const response = await post("api/validateEmail", {}, {});
    //   console.log("Resend response:", response.data);
    // } catch (error) {
    //   console.error("Resend failed:", error);
    // }
  }

  return (
    <div className={style.verifyContainer}>
      <div className={style.verifyCardCheck}>

        <h3 className={style.verifyTitle}>
        صلاحية هذا الرابط منتهية
        </h3>

        <button
          className={style.verifyBtn}
          onClick={() => navigate("/login")}
        >
         الرجوع لصفحة تسجيل الدخول
        </button>

        {/*<a
          href="#"
          className={loading ? style.disabledLink : style.verifyResend}
          // className={style.verifyResend}
          onClick={handleResend}
          disabled={loading}
        >
          إرسال بريد إعادة تعيين كلمة المرور مرة أخرى
        </a>*/}
        {errMessage && (
          <div className="alert alert-primary mt-4" role="alert">
            {errMessage}
          </div>
        )}

      </div>
    </div>
  );
}

export default CheckResetPassValidty;
